import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=1d76b944"
import script from "./ForgotPasswordPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=1d76b944&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports